import EventCalendar from "../components/EventCalendar";
import { FaRegUserCircle,FaRegCheckCircle, FaBirthdayCake, FaUserFriends, FaStar } from "react-icons/fa";
import { IoCalendarOutline, IoSearchSharp } from "react-icons/io5";
import { CiCalendar } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import { useContext, useEffect, useState } from "react";
import { base_url } from '../url_variables';
import axios from 'axios';
import { useCookies } from "react-cookie";
import { GridLoader } from "react-spinners";
import {TopBar} from '../components/topbar';
import { TostMessageContext } from "../context/TostMessage";
import { MenuContext } from "../context/MenuContext";
import { IoMdArrowRoundBack } from "react-icons/io";
import { MdOutlineBedroomParent } from "react-icons/md";


export default function BookApartment() {
    const navigate = useNavigate();
    const {userProfile, logOutFunction} = useContext(UserContext);
    const [cookies] = useCookies();
    const [formFields, setFormFields] = useState({});
    const [apartmentList, setApartmentList] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);
    const { setTostMessage } = useContext(TostMessageContext);
    const { menuOpen, setMenuOpen } = useContext(MenuContext)
    const [minCheckOut, setMinCheckOut] = useState(null);

    useEffect(() => {
      if (menuOpen) setMenuOpen(false);
      const { checkIn, checkOut } = getDefaultDates();
      setFormFields({...formFields, check_in: checkIn, check_out: checkOut, min_date: checkIn });
      setMinCheckOut(getNextDate(checkIn));

      getData();
    }, [])

    function formatDate(date) {
      return date.toISOString().split("T")[0];
    }

    function getDefaultDates() {
      const today = new Date();
      const tomorrow = new Date();
      tomorrow.setDate(today.getDate() + 1);

      return {
        checkIn: formatDate(today),
        checkOut: formatDate(tomorrow)
      };
    }

    async function getData() {
        const formData = new FormData();
        Object.entries(formFields).forEach(([key, value]) => {
          formData.append(key, value);
        });
        setPageLoading(true)
        try {
            const response = await axios.post(base_url + '/book-apartment.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.code == 403) {
                logOutFunction()
            }
            setPageLoading(false)
            if (response.data.status) {
              setApartmentList(response.data.data.apartments);
            } else {

            }
        } catch (error) {
          setPageLoading(false)
        }
    }

    const getNextDate = (date) => {
      if (!date) return "";
      const d = new Date(date);
      d.setDate(d.getDate() + 1);
      return d.toISOString().split("T")[0];
    };

  return (
    <div className="flex flex-col rounded-[10px] min-h-full bg-white">
      {pageLoading && (
      <div className="flex items-center justify-center h-full w-[-webkit-fill-available] z-[99] bg-[#ffffff] fixed opacity-[0.9]">
        <GridLoader
            color={'#037684'}
            loading={true}
            size={20}
            aria-label="Loading Spinner"
            data-testid="loader"
        />
      </div>
      )}
        {/* <h2 className="text-2xl text-[#037684] font-bold mb-4">Welcome, {userProfile?.name}</h2> */}
        <TopBar title={`Welcome, ${cookies?.userProfile?.name}`} />
        <div className="py-6 px-10 flex flex-col justify-start">
            <div className="flex items-center justify-start gap-x-3">
                <button onClick={() => navigate(-1)} className="p-2 border border-2 rounded-full"><IoMdArrowRoundBack size={20} /></button>
                <h2 className="text-2xl text-black font-bold">{'Reserve Apartment'}</h2>
            </div>
            <div className="animate-fadeIn mt-5 w-full bg-white rounded-3xl border p-6 shadow-sm flex flex-col gap-6 md:flex-row md:items-end md:gap-8">
              {/* Apartment Type */}
              <div className="flex-1">
                <label className="flex items-center gap-2 text-gray-500 text-sm mb-1">
                  <FaUserFriends className="w-5 h-5" />
                  Apartment Type
                </label>

                <div className="relative">
                  <select
                    className="w-full bg-transparent focus:outline-none text-gray-700 pr-6"
                    value={formFields?.apt_type}
                    onChange={(e) => setFormFields({...formFields, apt_type: e.target.value})}
                  >
                    <option value="any">Any</option>
                    <option value="1">1 Bedroom</option>
                    <option value="2">2 Bedroom</option>
                  </select>
                </div>

                <div className="border-b border-black mt-1" />
              </div>

              {/* Check-in */}
              <div className="flex-1">
                <label className="flex items-center gap-2 text-gray-500 text-sm mb-1">
                  <CiCalendar className="w-5 h-5" />
                  Check-in
                </label>

                <div className="flex items-center justify-between">
                  <input
                    type="date"
                    // min={formFields?.min_date}
                    className="w-full bg-transparent focus:outline-none text-gray-700"
                    value={formFields?.check_in}
                    onChange={(e) => {setFormFields({...formFields, check_in: e.target.value, check_out: getNextDate(e.target.value)});setMinCheckOut(getNextDate(e.target.value)); }}
                  />
                </div>

                <div className="border-b border-black mt-1" />
              </div>

              {/* Check-out */}
              <div className="flex-1">
                <label className="flex items-center gap-2 text-gray-500 text-sm mb-1">
                  <CiCalendar className="w-5 h-5" />
                  Check-out
                </label>

                <div className="flex items-center justify-between">
                  <input
                    type="date"
                    className="w-full bg-transparent focus:outline-none text-gray-700"
                    value={formFields?.check_out}
                    min={minCheckOut}
                    onChange={(e) => setFormFields({...formFields, check_out: e.target.value})}
                  />
                </div>

                <div className="border-b border-black mt-1" />
              </div>

              <div className="flex-1">
                <label className="flex items-center gap-2 text-gray-500 text-sm mb-1">
                  <IoSearchSharp className="w-5 h-5" />
                  Search
                </label>

                <div className="flex items-center justify-between">
                  <input
                    type="text"
                    placeholder="Apt. code or name"
                    className="w-full bg-transparent focus:outline-none text-gray-700"
                    value={formFields?.apt_search}
                    onChange={(e) => {setFormFields({...formFields, apt_search: e.target.value}); }}
                  />
                </div>

                <div className="border-b border-black mt-1" />
              </div>

              {/* Button */}
              <button 
              onClick={() => getData()}
              className="
                  bg-[#037684] text-white rounded-full font-semibold
                  px-8 py-3 transition hover:bg-primary
                  w-full md:w-auto md:self-center
                ">
                Check Dates
              </button>
            </div>
            <div className="search_results mt-10 grid justify-between grid-cols-1 md:grid-cols-4 gap-6 scroll-smooth no-scrollbar mx-auto">
                {apartmentList?.map((item, index) => {
                  return (
                    <div key={index} onClick={() => navigate(`/dashboard/confirm-reservation/${item.apartment_id}`, { state: {apt: item.apartment_id, apt_name: item.apt_name, check_in: formFields?.check_in, check_out: formFields?.check_out }}) } className="w-full md:w-[260px] flex-shrink-0 cursor-pointer animate-scaleIn">
                      <div className="relative">
                          <img src={item.image_uri} className="w-full h-60 object-cover rounded-2xl" />
                          
                          <div className="absolute top-3 left-3 bg-black/60 text-white text-sm px-2 py-1 rounded-md flex items-center gap-1">
                            <FaStar size={13} color='#FEDB37' /> {item.rating}
                          </div>
                          {item.clashing_date && 
                            <div className="font-cormorant-regular absolute bottom-3 right-3 bg-black/60 text-white text-sm px-2 py-1 rounded-md flex items-center gap-1">
                              <i className="fa-solid fa-circle-info text-[#ffffff]"></i> 1 or more dates clash
                            </div>
                          }
                      </div>
                      <div className="flex flex-row justify-between mt-4">
                          <div className="flex flex-col gap-y-2">
                            <h3 className="font-aileron-regular font-semibold">{item.apt_cat}</h3>
                            <h3 className="font-aileron-regular">{item.apt_name}</h3>
                            <span className="text-[15px] text-black flex flex-row items-center gap-x-2"><MdOutlineBedroomParent size={15} />{item.bedrooms} bedroom(s)</span>
                          </div>
                          <div className="flex flex-col items-end">
                              <button className="bg-primary px-3 py-1 rounded">
                                  <span className="text-white font-aileron-regular text-[15px]">{item.price}</span>
                              </button>
                              <span className="text-[#C4A17A] font-cormorant-bold text-[15px]">{item.duration} Night(s)</span>
                          </div>
                      </div>
                  </div>
                  )
                })}
            </div>
        </div>
    </div>
  );
}
